import { fromFetch } from 'rxjs/fetch';
import { AuthHeaders } from '../../models/auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { selectData } from '../../utils/select-data';
import { accountsEnvironment } from './accounts-environment';
import { copilotActionsSchema } from './schemas/copilot-actions.schema';

export function getCopilotActions() {
  return fromFetch(
    new Request(accountsEnvironment.copilotActionsUrl, {
      method: 'GET',
      headers: {
        ...requiredHeaders,
        ...new AuthHeaders(),
      },
    })
  ).pipe(selectData(copilotActionsSchema));
}
